import React from 'react';

const ModernTemplate = ({ resumeData }) => {
    return (
        <div className="bg-white w-[210mm] min-h-[297mm] shadow-2xl origin-top transform scale-[0.4] md:scale-[0.65] lg:scale-[0.85] xl:scale-100 transition-transform duration-300 p-[20mm] text-slate-800" id="resume-preview">

            {/* Header */}
            <div className="border-b-2 border-slate-800 pb-6 mb-8">
                <h1 className="text-4xl font-bold uppercase tracking-tight mb-4 text-slate-900 break-words">{resumeData.personal.fullName || "Your Name"}</h1>
                <div className="flex flex-wrap gap-4 text-sm text-slate-600">
                    {resumeData.personal.email && <span>{resumeData.personal.email}</span>}
                    {resumeData.personal.phone && <span>• {resumeData.personal.phone}</span>}
                    {resumeData.personal.location && <span>• {resumeData.personal.location}</span>}
                </div>
            </div>

            {/* Summary */}
            {resumeData.personal.summary && (
                <div className="mb-8">
                    <h2 className="text-sm font-bold uppercase tracking-widest text-slate-400 mb-3">Professional Profile</h2>
                    <p className="text-sm leading-relaxed text-slate-700 text-justify">{resumeData.personal.summary}</p>
                </div>
            )}

            {/* Dynamic Sections */}
            {resumeData.sectionOrder.map((sectionId) => {
                if (sectionId === 'experience' && resumeData.experience.length > 0) {
                    return (
                        <div key={sectionId} className="mb-8">
                            <h2 className="text-sm font-bold uppercase tracking-widest text-slate-400 mb-4">Work Experience</h2>
                            <div className="space-y-6">
                                {resumeData.experience.map((exp) => (
                                    <div key={exp.id} className="resume-item">
                                        <div className="flex justify-between items-baseline mb-1">
                                            <h3 className="font-bold text-lg text-slate-800">{exp.role}</h3>
                                            <span className="text-sm font-medium text-slate-500 bg-slate-100 px-2 py-0.5 rounded">{exp.startDate} - {exp.endDate}</span>
                                        </div>
                                        <div className="text-sm font-semibold text-blue-600 mb-2">{exp.company} {exp.location && `• ${exp.location}`}</div>
                                        <p className="text-sm leading-relaxed text-slate-600 whitespace-pre-line">{exp.description}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                }

                if (sectionId === 'education' && resumeData.education.length > 0) {
                    return (
                        <div key={sectionId} className="mb-8">
                            <h2 className="text-sm font-bold uppercase tracking-widest text-slate-400 mb-4">Education</h2>
                            <div className="space-y-4">
                                {resumeData.education.map((edu) => (
                                    <div key={edu.id} className="resume-item">
                                        <div className="flex justify-between items-baseline mb-1">
                                            <h3 className="font-bold text-lg text-slate-800">{edu.school}</h3>
                                            <span className="text-sm font-medium text-slate-500 bg-slate-100 px-2 py-0.5 rounded">{edu.year}</span>
                                        </div>
                                        <div className="text-sm text-slate-600">{edu.degree} {edu.location && `• ${edu.location}`}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                }

                if (sectionId === 'skills' && resumeData.skills.length > 0) {
                    return (
                        <div key={sectionId} className="mb-8">
                            <h2 className="text-sm font-bold uppercase tracking-widest text-slate-400 mb-4">Skills</h2>
                            <div className="flex flex-wrap gap-2">
                                {resumeData.skills.map((skill, idx) => (
                                    <span key={idx} className="bg-slate-100 text-slate-700 px-3 py-1 rounded-full text-sm font-medium">
                                        {skill}
                                    </span>
                                ))}
                            </div>
                        </div>
                    );
                }

                if (typeof sectionId === 'number') {
                    const section = resumeData.customSections.find(s => s.id === sectionId);
                    if (section && section.items.length > 0) {
                        return (
                            <div key={sectionId} className="mb-8">
                                <h2 className="text-sm font-bold uppercase tracking-widest text-slate-400 mb-4">{section.title}</h2>
                                <div className="space-y-4">
                                    {section.items.map((item) => (
                                        <div key={item.id} className="resume-item">
                                            <div className="flex justify-between items-baseline mb-1">
                                                <h3 className="font-bold text-lg text-slate-800">{item.title}</h3>
                                                {item.subtitle && <span className="text-sm font-medium text-slate-500 bg-slate-100 px-2 py-0.5 rounded">{item.subtitle}</span>}
                                            </div>
                                            {item.subtext && <div className="text-sm font-semibold text-blue-600 mb-2">{item.subtext}</div>}
                                            {item.description && <p className="text-sm leading-relaxed text-slate-600 whitespace-pre-line">{item.description}</p>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    }
                }

                return null;
            })}
        </div>
    );
};

export default ModernTemplate;
